import type {PerkUsageViewComponentProps} from '@cohort/merchants/apps';
import {PerkUsageLayout} from '@cohort/merchants/components/perks/PerkUsageLayout';
import {CohortPromoCodeUsageDataSchema} from '@cohort/shared/apps/cohort/perks/promoCode';
import {useTranslation} from 'react-i18next';

const CohortPromoCodePerkIntegrationsUsageViewComponent: React.FC<PerkUsageViewComponentProps> = ({
  usage,
}) => {
  const {t} = useTranslation('app-cohort', {
    keyPrefix: 'perkIntegrations.promo-code.usageViewComponent',
  });

  const data = CohortPromoCodeUsageDataSchema.parse(usage.data);

  return (
    <PerkUsageLayout.Grid>
      <PerkUsageLayout.Row name={t('userUsedCode')} value={data.code} />
    </PerkUsageLayout.Grid>
  );
};

export default CohortPromoCodePerkIntegrationsUsageViewComponent;
